enum GatheringViewMethod {
  FullPublic = 'FullPublic',
  Main = 'Main',
  PublicPreview = 'PublicPreview',
  Restricted = 'Restricted'
}
export default GatheringViewMethod
